import React, { useState } from 'react';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
  Container,
} from '@mui/material';
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Dashboard as DashboardIcon,
  Article as ArticleIcon,
  Newspaper as NewspaperIcon,
  QuestionAnswer as FaqIcon,
  ContactSupport as EnquiryIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  AccountCircle,
  Image as ImageIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

const drawerWidth = 260;

const Logo = ({ collapsed }) => {
  if (collapsed) {
    return (
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '8px',
          background: 'linear-gradient(98.76deg, #3C60B6 -45.06%, #3C60B6 34.8%, #4EB2CE 114.24%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 800,
          fontSize: '20px',
          cursor: 'pointer',
          boxShadow: '0px 4px 10px rgba(60, 96, 182, 0.2)',
        }}
      >
        R
      </Box>
    );
  }

  return (
    <Box sx={{ height: 35, display: 'flex', alignItems: 'center', cursor: 'pointer', px: 2, py: 4 }}>
      <svg width="127" height="34" viewBox="0 0 127 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="admin_mask0" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="14" y="13" width="16" height="21">
          <path d="M16.9013 32.6947C14.1168 31.0857 14.2557 25.6329 17.2117 20.5123C20.1676 15.3933 24.8213 12.5462 27.6059 14.1537C30.3906 15.7613 30.2516 21.2155 27.2956 26.3346C24.3396 31.4552 19.686 34.3023 16.9013 32.6947Z" fill="white"/>
        </mask>
        <g mask="url(#admin_mask0)">
          <path d="M16.9013 32.6948C14.1168 31.0858 14.2557 25.633 17.2117 20.5124C20.1676 15.3933 24.8213 12.5463 27.6059 14.1538C30.3906 15.7613 30.2516 21.2156 27.2956 26.3347C24.3396 31.4552 19.686 34.3023 16.9013 32.6948Z" fill="url(#admin_paint0)"/>
        </g>
        <mask id="admin_mask1" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="4" width="15" height="20">
          <path d="M2.00097 4.77338C4.78547 3.16585 9.43912 6.01292 12.3951 11.1335C15.3511 16.2526 15.4901 21.7068 12.7054 23.3144C9.92078 24.9219 5.26713 22.0748 2.31115 16.9543C-0.644831 11.8352 -0.783681 6.38091 2.00097 4.77338Z" fill="white"/>
        </mask>
        <g mask="url(#admin_mask1)">
          <path d="M2.00097 4.77345C4.78547 3.16591 9.43912 6.01299 12.3951 11.1335C15.3511 16.2526 15.4901 21.7069 12.7054 23.3144C9.92078 24.922 5.26713 22.0749 2.31115 16.9543C-0.644831 11.8353 -0.783681 6.38098 2.00097 4.77345Z" fill="url(#admin_paint1)"/>
        </g>
        <mask id="admin_mask2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="12" y="0" width="22" height="12">
          <path d="M33.6186 5.82222C33.6186 9.03728 28.8261 11.6445 22.9141 11.6445C17.0022 11.6445 12.2095 9.03728 12.2095 5.82222C12.2095 2.60716 17.0022 -5.24521e-05 22.9141 -5.24521e-05C28.8261 -5.24521e-05 33.6186 2.60716 33.6186 5.82222Z" fill="white"/>
        </mask>
        <g mask="url(#admin_mask2)">
          <path d="M33.6186 5.82228C33.6186 9.03734 28.8261 11.6446 22.9141 11.6446C17.0022 11.6446 12.2095 9.03734 12.2095 5.82228C12.2095 2.60722 17.0022 8.58307e-06 22.9141 8.58307e-06C28.8261 8.58307e-06 33.6186 2.60722 33.6186 5.82228Z" fill="url(#admin_paint2)"/>
        </g>
        <path d="M40.0809 28.0625C39.6719 28.0625 39.3142 27.918 39.0079 27.6275C38.7014 27.34 38.5477 26.9899 38.5477 26.5802V14.1117C38.5477 12.8871 38.7859 11.728 39.2635 10.6374C39.74 9.54688 40.3872 8.59338 41.2051 7.77546C42.023 6.95903 42.9759 6.31096 44.0665 5.83421C45.1563 5.35746 46.3149 5.11909 47.5418 5.11909H50.0455C50.4544 5.11909 50.812 5.26509 51.1184 5.55262C51.4248 5.84165 51.5787 6.19177 51.5787 6.59998C51.5787 7.00969 51.4248 7.3583 51.1184 7.64733C50.812 7.93785 50.4544 8.08237 50.0455 8.08237H47.5418C46.7239 8.08237 45.9489 8.24327 45.2166 8.56656C44.4838 8.89135 43.8534 9.32638 43.3257 9.87017C42.7974 10.4154 42.3715 11.0546 42.0483 11.7876C41.7244 12.5206 41.5628 13.2938 41.5628 14.1117V26.5802C41.5628 26.9899 41.4174 27.34 41.1285 27.6275C40.8383 27.918 40.4898 28.0625 40.0809 28.0625Z" fill="#100F0D"/>
        <path d="M63.5865 8.13302C62.4279 8.13302 61.329 8.35501 60.2904 8.79898C59.2505 9.24146 58.3489 9.84633 57.5822 10.6121C56.8157 11.3779 56.2101 12.2822 55.768 13.3206C55.3247 14.3605 55.104 15.4585 55.104 16.6161C55.104 17.7737 55.3247 18.8732 55.768 19.9131C56.2101 20.9516 56.8157 21.8529 57.5822 22.6202C58.3489 23.3859 59.2505 23.9908 60.2904 24.4348C61.329 24.8773 62.4279 25.0993 63.5865 25.0993C64.744 25.0993 65.8429 24.8773 66.8822 24.4348C67.9208 23.9908 68.8244 23.3859 69.5903 22.6202C70.357 21.8529 70.9612 20.9516 71.4046 19.9131C71.8466 18.8732 72.0686 17.7737 72.0686 16.6161C72.0686 15.4585 71.8466 14.3605 71.4046 13.3206C70.9612 12.2822 70.357 11.3779 69.5903 10.6121C68.8244 9.84633 67.9208 9.24146 66.8822 8.79898C65.8429 8.35501 64.744 8.13302 63.5865 8.13302ZM63.5865 28.0625C61.9845 28.0625 60.4948 27.7646 59.1148 27.1686C57.7355 26.5727 56.5171 25.7548 55.4616 24.7164C54.4048 23.6765 53.5786 22.4667 52.9832 21.0871C52.3867 19.7075 52.0887 18.2177 52.0887 16.6161C52.0887 15.0488 52.3867 13.5679 52.9832 12.1705C53.5786 10.7745 54.4048 9.54687 55.4616 8.49058C56.5171 7.43578 57.7355 6.60892 59.1148 6.01299C60.4948 5.41705 61.329 5.11909 63.5865 5.11909C65.153 5.11909 66.6349 5.41705 68.0318 6.01299C69.4286 6.60892 70.6549 7.43578 71.7109 8.49058C72.7665 9.54687 73.5935 10.7745 74.1893 12.1705C74.7852 13.5679 75.0837 15.0488 75.0837 16.6161C75.0837 18.2177 74.7852 19.7075 74.1893 21.0871C73.5935 22.4667 72.7665 23.6765 71.7109 24.7164C70.6549 25.7548 69.4286 26.5727 68.0318 27.1686C66.6349 27.7646 65.153 28.0625 63.5865 28.0625Z" fill="#100F0D"/>
        <path d="M79.4777 28.0625C79.0349 28.0625 78.6681 27.9091 78.3792 27.6037C78.0891 27.2953 77.9451 26.9392 77.9451 26.5295V16.5655C77.9451 14.9982 78.243 13.5158 78.8388 12.1198C79.4348 10.7224 80.261 9.49622 81.3172 8.43993C82.3733 7.38512 83.5917 6.55826 84.9711 5.96233C86.351 5.36639 87.8408 5.06694 89.4421 5.06694C91.0091 5.06694 92.4911 5.36639 93.8879 5.96233C95.2842 6.55826 96.5111 7.38512 97.5672 8.43993C98.6226 9.49622 99.4489 10.7224 100.045 12.1198C100.641 13.5158 100.94 14.9982 100.94 16.5655V26.5295C100.94 26.9392 100.795 27.2953 100.506 27.6037C100.216 27.9091 99.8495 28.0625 99.4067 28.0625C98.9978 28.0625 98.6486 27.9091 98.3591 27.6037C98.0696 27.2953 97.9248 26.9392 97.9248 26.5295V16.5655C97.9248 15.4079 97.7028 14.3084 97.2608 13.27C96.8174 12.2316 96.2131 11.3272 95.4465 10.5615C94.6799 9.79419 93.7769 9.19081 92.7384 8.74684C91.6985 8.30435 90.6002 8.08237 89.4421 8.08237C88.2498 8.08237 87.143 8.30435 86.1207 8.74684C85.099 9.19081 84.2045 9.79419 83.4378 10.5615C82.6719 11.3272 82.0662 12.2316 81.6242 13.27C81.1808 14.3084 80.9595 15.4079 80.9595 16.5655V26.5295C80.9595 26.9392 80.8148 27.2953 80.5253 27.6037C80.2357 27.9091 79.8865 28.0625 79.4777 28.0625Z" fill="#100F0D"/>
        <path d="M115.503 8.13302C114.344 8.13302 113.246 8.35501 112.207 8.79898C111.167 9.24146 110.265 9.84633 109.499 10.6121C108.732 11.3779 108.126 12.2822 107.684 13.3206C107.241 14.3605 107.02 15.4585 107.02 16.6161C107.02 17.7737 107.241 18.8732 107.684 19.9131C108.126 20.9516 108.732 21.8529 109.499 22.6202C110.265 23.3859 111.167 23.9908 112.207 24.4348C113.246 24.8773 114.344 25.0993 115.503 25.0993C116.661 25.0993 117.759 24.8773 118.799 24.4348C119.837 23.9908 120.741 23.3859 121.507 22.6202C122.273 21.8529 122.878 20.9516 123.322 19.9131C123.763 18.8732 123.985 17.7737 123.985 16.6161C123.985 15.4585 123.763 14.3605 123.322 13.3206C122.878 12.2822 122.273 11.3779 121.507 10.6121C120.741 9.84633 119.837 9.24146 118.799 8.79898C117.759 8.35501 116.661 8.13302 115.503 8.13302ZM115.503 28.0625C113.901 28.0625 112.411 27.7646 111.031 27.1686C109.652 26.5727 108.433 25.7548 107.378 24.7164C106.321 23.6765 105.495 22.4667 104.9 21.0871C104.303 19.7075 104.005 18.2177 104.005 16.6161C104.005 15.0488 104.303 13.5679 104.9 12.1705C105.495 10.7745 106.321 9.54687 107.378 8.49058C108.433 7.43578 109.652 6.60892 111.031 6.01299C112.411 5.41705 113.901 5.11909 115.503 5.11909C117.069 5.11909 118.551 5.41705 119.949 6.01299C121.345 6.60892 122.571 7.43578 123.627 8.49058C124.683 9.54687 125.51 10.7745 126.106 12.1705C126.702 13.5679 127 15.0488 127 16.6161C127 18.2177 126.702 19.7075 126.106 21.0871C125.51 22.4667 124.683 23.6765 123.627 24.7164C122.571 25.7548 121.345 26.5727 119.949 27.1686C118.551 27.7646 117.069 28.0625 115.503 28.0625Z" fill="#100F0D"/>
        <defs>
          <linearGradient id="admin_paint0" x1="11.0142" y1="34.6629" x2="34.7342" y2="10.9429" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F25828"/>
            <stop offset="1" stopColor="#F7CE25"/>
          </linearGradient>
          <linearGradient id="admin_paint1" x1="12.7054" y1="23.3144" x2="2.00085" y2="4.77359" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3C60B6"/>
            <stop offset="0.00495049" stopColor="#3C60B6"/>
            <stop offset="1" stopColor="#4EB2CE"/>
          </linearGradient>
          <linearGradient id="admin_paint2" x1="4.28257" y1="5.82228" x2="46.7429" y2="5.82228" gradientUnits="userSpaceOnUse">
            <stop stopColor="#5E3EA1"/>
            <stop offset="2.8e-07" stopColor="#5E3EA1"/>
            <stop offset="1" stopColor="#8B359E"/>
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
};

const AdminLayout = () => {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggleDrawer = () => {
    setOpen(!open);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin/dashboard' },
    { text: 'Blogs', icon: <ArticleIcon />, path: '/admin/blogs' },
    { text: 'News', icon: <NewspaperIcon />, path: '/admin/news' },
    { text: 'Enquiries', icon: <EnquiryIcon />, path: '/admin/enquiries' },
    { text: 'FAQs', icon: <FaqIcon />, path: '/admin/faqs' },
    { text: 'Logos', icon: <ImageIcon />, path: '/admin/logos' },
    { text: 'Settings', icon: <SettingsIcon />, path: '/admin/settings' },
  ];

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#F8F9FA' }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 80px)`,
          ml: open ? `${drawerWidth}px` : '80px',
          transition: (theme) => theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleToggleDrawer}
            edge="start"
            sx={{ mr: 2, color: '#666' }}
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Tooltip title="Account settings">
              <IconButton
                onClick={handleMenuOpen}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={anchorEl ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={anchorEl ? 'true' : undefined}
              >
                <Avatar sx={{ width: 35, height: 35, bgcolor: '#3C60B6', fontWeight: 600, fontSize: '14px' }}>AD</Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              onClick={handleMenuClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                    mt: 1.5,
                    borderRadius: '12px',
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={() => navigate('/admin/settings')}>
                <ListItemIcon>
                  <SettingsIcon fontSize="small" />
                </ListItemIcon>
                Settings
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout} sx={{ color: '#d32f2f' }}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" sx={{ color: '#d32f2f' }} />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: open ? drawerWidth : 80,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: open ? drawerWidth : 80,
            transition: (theme) => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            overflowX: 'hidden',
          },
        }}
      >
        <Logo collapsed={!open} />
        <Divider sx={{ mx: 2, mb: 1, opacity: 0.5 }} />
        <List sx={{ px: 1.5 }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <ListItem key={item.text} disablePadding sx={{ display: 'block', mb: 0.5 }}>
                <ListItemButton
                  onClick={() => navigate(item.path)}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                    borderRadius: '10px',
                    bgcolor: isActive ? 'rgba(60, 96, 182, 0.08)' : 'transparent',
                    color: isActive ? '#3C60B6' : '#666',
                    '&:hover': {
                      bgcolor: isActive ? 'rgba(60, 96, 182, 0.12)' : 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 2 : 'auto',
                      justifyContent: 'center',
                      color: isActive ? '#3C60B6' : '#666',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={item.text} 
                    sx={{ 
                      opacity: open ? 1 : 0,
                      '& .MuiTypography-root': { fontWeight: isActive ? 700 : 500 }
                    }} 
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        <Box sx={{ mt: 'auto', p: 2 }}>
          {open && (
            <Box sx={{ bgcolor: 'rgba(242, 88, 40, 0.05)', p: 2, borderRadius: '12px' }}>
              <Typography variant="caption" sx={{ color: '#F25828', fontWeight: 700, display: 'block', mb: 0.5 }}>
                NEED HELP?
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', fontSize: '12px' }}>
                Contact technical support for assistance.
              </Typography>
            </Box>
          )}
        </Box>
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${open ? drawerWidth : 80}px)` },
          minHeight: '100vh',
          transition: (theme) => theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default AdminLayout;
